<style lang="scss" scoped="scoped">
// ::-webkit-scrollbar {
// 	width: 0 !important
// }
.gradient-text-one {
  background-image: -webkit-linear-gradient(#85fdff, #ffffff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

::-webkit-scrollbar {
  display: none;
}

.vue-grid-item {
  background: #202027;
  // overflow: auto;
  box-sizing: border-box;
  position: relative;
}

.vue-grid-item.vue-grid-placeholder {
  background: #419fff !important;
}

.el-dropdown-link {
  cursor: pointer;
  color: #419fff;
}

.bg {
  background: #121212;
}

// .vue-grid-layout::-webkit-scrollbar {
// 	width: 0 !important
// }

.module-grid {
  background: #636363;
}
</style>
<style lang="scss">
.el-popper {
  margin-right: 10px;
}

.monitorEfficiency .el-input__inner {
  color: #419fff;
  border: none;
  background-color: transparent;
  text-align: right;
  width: 260px;
}

.monitorEfficiency .el-cascader .el-input .el-icon-arrow-down {
  color: #419fff;
}

.monitorEfficiency .el-input__inner::-webkit-input-placeholder {
  color: #419fff;
}
</style>

<template>
  <div style="display: inline;">
    <div class="bg" style="position: absolute;height: 100%;width: 100%;box-sizing: border-box;" :style="{ background: monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? '#121212' : '#000355' }">
      <div ref="header" style="padding: 8px 0px  0px  0px;">
        <div :style="{ 'background-image': 'url(' + require(monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? '@@/assets/img/web/manufacturing/header.png' : '@@/assets/img/web/manufacturing/header2.png') + ')' }" style="border-radius: 2px;width: 100%;height: 66px;padding:0px 20px;display: flex;justify-content: space-between;align-items: center;background-size: 100% 100%;background-repeat: repeat;">
          <div style="width: 340px;cursor: pointer;">
            <img @click="utils.event_hub.$emit('TOGGLE_TABBAR', !store.state.is_monitor_full)" style="width: 176px;height: 38px;" :src="require(monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? '@@/assets/img/web/workshop/logo.png' : '@@/assets/img/web/manufacturing/logo.png')" />
          </div>
          <div class="gradient-text-one" style="font-weight: 700;font-size: 30px;color: white;">
            {{ titleName }}
            <span v-if="littleName || titleName != ''">-</span>
            {{ littleName }}
          </div>
          <div class="monitorEfficiency" style="width: 340px;display: flex;flex-direction: column;justify-content: center;align-items: flex-end;">
            <p style="font-size: 14px;color:white;">{{ store.state.currentTime }}</p>
            <div style="display: flex;align-items: center;">
              <yi_data_select :type="'organization'" :ids.sync="orgId"> </yi_data_select>
              <el-link @click="showBoardEdit()" style="color:#419FFF ;margin-left: 8px;font-size: 12px;" icon="yicon yicon-pencil">
                {{ $t("bianjikanban") }}
              </el-link>
            </div>
          </div>
        </div>
      </div>
      <div style="padding: 10px 10px 20px  10px;">
        <grid-layout v-if="gridContainerHeight != 0" :layout.sync="layout" :col-num="24" :maxRows="24" :row-height="gridRowHeihgt" :is-draggable="false" :is-resizable="false" :is-mirrored="false" :vertical-compact="true" :margin="[10, 10]" :use-css-transforms="true" :style="{ height: gridContainerHeight + 'px' }" style="overflow: auto;">
          <grid-item :refs="'grid_' + item.i" v-for="item in layout" :x="item.x" :y="item.y" :w="item.w" :h="item.h" :i="item.i" :key="item.i">
            <component v-bind:is="item.i" :orgId="orgId" :shift="shift" :monitorSetting="monitorSetting"> </component>
          </grid-item>
        </grid-layout>
      </div>
    </div>
    <el-dialog :show-close="true" :title="$t('kanbanshezhi')" :visible.sync="isShowBoardEdit" :close-on-click-modal="false" width="874px" append-to-body>
      <setting ref="setting"></setting>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="isShowBoardEdit = false">{{ $t("quxiao") }}</el-button>
        <el-button size="mini" @click="
          $refs.setting.save();
        isShowBoardEdit = false;
        " type="primary">
          {{ $t("baocun") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import VueGridLayout from "vue-grid-layout";
import factory from "@@/pages/web/monitor/manufacturing/factory";
import uprate from "@@/pages/web/monitor/manufacturing/uprate";
import analysis from "@@/pages/web/monitor/manufacturing/analysis";
import output1 from "@@/pages/web/monitor/manufacturing/output";
import runrate from "@@/pages/web/monitor/manufacturing/runrate";
import efficiency from "@@/pages/web/monitor/manufacturing/efficiency";
import task from "@@/pages/web/monitor/manufacturing/task";
import setting from "@@/pages/web/monitor/manufacturing/setting";

export default {
  name: "web_monitor_manufacturing_index",
  components: {
    uprate: uprate,
    factory: factory,
    analysis: analysis,
    output1: output1,
    runrate: runrate,
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    efficiency: efficiency,
    task: task,
    setting: setting,
  },

  data() {
    return {
      titleName: '',
      littleName: '',
      monitorSetting: {},
      isShowBoardEdit: false,
      timer: null,
      orgId: this.store.state.organizations[0].id,
      gridContainerHeight: 0,
      gridRowHeihgt: 0,
      shift: {},
      layout: [
        {
          x: 0,
          y: 0,
          w: 5,
          h: 6, //应该是6
          i: "output1",
        },
        {
          x: 0,
          y: 6,
          w: 5,
          h: 6, //应该是6
          i: "runrate",
        },
        {
          x: 5,
          y: 0,
          w: 14,
          h: 12, //应该是6
          i: "factory",
        },
        {
          x: 19,
          y: 0,
          w: 5,
          h: 6, //应该是6
          i: "uprate",
        },
        {
          x: 19,
          y: 6,
          w: 5,
          h: 6, //应该是6
          i: "analysis",
        },

        {
          x: 0,
          y: 12,
          w: 12,
          h: 12,
          i: "task",
        },
        {
          x: 12,
          y: 12,
          w: 12,
          h: 12, //应该是18
          i: "efficiency",
        },
      ],
    };
  },

  created() {
    this.setManufacturingTemplate();
    this.utils.event_hub.$emit("TOGGLE_TABBAR", true);
    this.timer = setInterval(() => {
      this.getBasicShift();
    }, 300000);
    this.getBasicShift();
  },
  activated() {
    this.resize();
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });
    this.utils.event_hub.$on("SetManufacturingTemplate", () => {
      this.setManufacturingTemplate();
    });
  },
  destroyed() {
    this.utils.event_hub.$off("SetManufacturingTemplate");

    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    async getBasicShift() {
      let response = await this.http.get("/web/board/efficiency/index/getBasicShift", { params: { orgId: this.$attrs.orgId } });
      this.shift = response.data;
    },
    setManufacturingTemplate() {
      this.monitorSetting = JSON.parse(localStorage.getItem("MONITOR_SETTING"));
      if (this.monitorSetting == null) {
        this.monitorSetting = {};
      }
      if (this.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == null) {
        this.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE = "black";
      }
      if (this.monitorSetting["MONITOR_MANUFACTURING_HEADER_" + this.store.state.customer.id] != null) {
        this.titleName = this.monitorSetting["MONITOR_MANUFACTURING_HEADER_" + this.store.state.customer.id];
      } else {
        this.titleName = this.store.state.customer.shortName
      }
      if (this.monitorSetting["MONITOR_MANUFACTURING_CARD_TITLE_" + this.store.state.customer.id] != null) {
        this.littleName = this.monitorSetting["MONITOR_MANUFACTURING_CARD_TITLE_" + this.store.state.customer.id];
      } else {
        this.littleName = this.$t('zhinengzhizaojiankong')
      }
    },
    showBoardEdit() {
      this.isShowBoardEdit = true;
      this.$nextTick(() => {
        this.$refs.setting.resetData();
      });
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.header) {
          return;
        }
        this.gridContainerHeight = this.store.state.router_view_height - this.$refs.header.offsetHeight - 31;
        this.gridRowHeihgt = (this.gridContainerHeight - 240) / 24;

        // for (var i = 0; i < this.layout.length; i++) {
        // 	if(this.$refs['grid_'+this.layout[i].i]!=null){
        // 		console.log(this.$refs['grid_'+this.layout[i].i])
        // 		this.$refs['grid_'+this.layout[i].i].resize()
        // 	}
        // }
      }, 500);
    },
  },
};
</script>
